(() => {
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.__bvHomeEventsBound) return;
  window.__bvHomeEventsBound = true;

  const analyticsAllowed = () => {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    return Boolean(
      privacy &&
      typeof privacy.analyticsProcessingAllowed === 'function' &&
      privacy.analyticsProcessingAllowed()
    );
  };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element
      ? event.target.closest('[data-bv-event]')
      : null;

    if (!target || !analyticsAllowed()) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: `bv_${target.dataset.bvEvent}`,
      bv_placement: target.dataset.bvPlacement || '',
      bv_product: target.dataset.bvProduct || ''
    });
  });
})();
